import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  discipline: Factory.extend({
    name: (i) => `${i} ${faker.lorem.sentence()}`,
    image: (i) => `https://picsum.photos/600/400?random=${i}`,
  }),
};
